import { defineStore } from 'pinia';

export const useOrderStore = defineStore('order', {
    state: () => ({
        vendor: null,
        itemsByVendor: {},
        address: {
            address: '',
            city: '',
            postcode: ''
        },
        orderId: null,
        paymentSent: false,
        deliveryFee: 0,
        deliveryFreeOrdersOver: null,
        referral: null
    }),
    getters: {
        currentVendorItems(state) {
            return state.itemsByVendor[state.vendor?.vId] || [];
        },
        itemSubtotal(state) {
            return this.currentVendorItems.reduce((sum, i) => {
                let total = i.item.price;
                for (const opt of i.options || []) {
                    const def = i.item.options.find(o => o.id === opt.optionId)?.choices.find(c => c.id === opt.choiceId);
                    if (def?.priceAdjustment) total += def.priceAdjustment;
                }
                return sum + total * i.quantity;
            }, 0);
        },
        totalAmount(state) {
            return this.itemSubtotal + (this.actualDeliveryFee || 0);
        },
        actualDeliveryFee(state) {
            return state.deliveryFreeOrdersOver != null && this.itemSubtotal >= state.deliveryFreeOrdersOver
                ? 0
                : state.deliveryFee;
        }
    },
    actions: {
        setReferral(referral) {
            if (referral) {
                this.referral = referral
            }
        },
        setVendor(vendor) {
            this.vendor = vendor;
            this.deliveryFee = vendor.deliveryFee ?? 0;
            this.deliveryFreeOrdersOver = vendor.deliveryFreeOrdersOver ?? null;
            console.log(this.deliveryFreeOrdersOver)
        },
        
        addToCart(item) {
            const vendorId = this.vendor?.vId;
            if (!vendorId) return;

            if (!this.itemsByVendor[vendorId]) this.itemsByVendor[vendorId] = [];

            const isSameItem = (a, b) => {
                if (a.itemId !== b.itemId) return false;
                if ((a.options?.length || 0) !== (b.options?.length || 0)) return false;
                if ((a.dietaryRequirements?.length || 0) !== (b.dietaryRequirements?.length || 0)) return false;

                const sortOptions = (opts) => [...opts].sort((x, y) => x.optionId - y.optionId || x.choiceId - y.choiceId);
                const optsA = sortOptions(a.options || []);
                const optsB = sortOptions(b.options || []);
                if (!optsA.every((opt, idx) => opt.optionId === optsB[idx].optionId && opt.choiceId === optsB[idx].choiceId)) return false;

                const dietA = [...(a.dietaryRequirements || [])].sort();
                const dietB = [...(b.dietaryRequirements || [])].sort();
                return dietA.every((val, idx) => val === dietB[idx]);
            };

            const existing = this.itemsByVendor[vendorId].find(i => isSameItem(i, item));

            if (existing) {
                existing.quantity += item.quantity;
            } else {
                // ensure dietaryRequirements is always defined
                this.itemsByVendor[vendorId].push({
                    ...item,
                    dietaryRequirements: item.dietaryRequirements || []
                });
            }
        },

        removeFromCart(itemToRemove) {
            const vendorId = this.vendor?.vId;
            if (!this.itemsByVendor[vendorId]) return;

            const isSameItem = (a, b) => {
                if (a.itemId !== b.itemId) return false;
                if ((a.options?.length || 0) !== (b.options?.length || 0)) return false;
                if ((a.dietaryRequirements?.length || 0) !== (b.dietaryRequirements?.length || 0)) return false;

                const sortOptions = (opts) => [...opts].sort((x, y) => x.optionId - y.optionId || x.choiceId - y.choiceId);
                const optsA = sortOptions(a.options || []);
                const optsB = sortOptions(b.options || []);

                const optsEqual = optsA.every((opt, idx) =>
                    opt.optionId === optsB[idx].optionId && opt.choiceId === optsB[idx].choiceId
                );

                if (!optsEqual) return false;

                const sortedDietA = [...(a.dietaryRequirements || [])].sort();
                const sortedDietB = [...(b.dietaryRequirements || [])].sort();

                return sortedDietA.length === sortedDietB.length &&
                    sortedDietA.every((v, i) => v === sortedDietB[i]);
            };

            this.itemsByVendor[vendorId] = this.itemsByVendor[vendorId].filter(i => !isSameItem(i, itemToRemove));
        },
        setAddress(address) {
            this.address = address;
        },
        setOrderId(id) {
            this.orderId = id;
        },
        setPaymentSent(val) {
            this.paymentSent = val;
        },
        clear() {
            this.vendor = null;
            this.itemsByVendor = {};
            this.address = {
                address: '',
                city: '',
                postcode: ''
            };
            this.orderId = null;
            this.paymentSent = false;
            this.deliveryFee = 0;
            this.deliveryFreeOrdersOver = null;
        }
    },

    persist: true
});
